export const USER_LOAD_SUCCESS = 'user/LOAD_SUCCESS';
export const SET_BUSY = 'user/SET_BUSY';
export const UNSET_BUSY = 'user/UNSET_BUSY';
export const SELECT_USER = 'user/SELECT_USER';
export const USER_DELETE_SUCCESS = 'user/DELETE_SUCCESS';
export const USER_CREATE_SUCCESS = 'user/CREATE_SUCCESS';
export const USER_EDIT_SUCCESS = 'user/EDIT_SUCCESS';
export const ADMIN_REMOVE_SUCCESS = 'admin/REMOVE_SUCCESS';
export const ADMIN_CHANGE_SUCCESS = 'admin/CHANGE_SUCCESS';